import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';

const LandingPage = lazyRetry(() => import('./LandingPage'));

/**
 * Public marketing page. auth: null makes it reachable by guests and
 * signed-in users alike (same pattern as the 404 page); '/' keeps its
 * existing redirect-to-sign-in behavior.
 */
const LandingPageRoute: FuseRouteItemType = {
  path: 'landing',
  element: <LandingPage />,
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        },
        leftSidePanel: {
          display: false
        },
        rightSidePanel: {
          display: false
        }
      }
    }
  },
  auth: null
};

export default LandingPageRoute;
